import { useMemo } from "react";
import dayjs from "dayjs";
import { CurrencyConverter } from "../Unit/CurrencyConverter";

export const useChartData = ({
  dailyMap,
  startDate,
  endDate,
  type,
  field,
  cal1,
  cal2,
  unit,
  currency,
  usdRate,
  cpm,
}) => {

  return useMemo(() => {

    const labels = [];
    const data = [];

    let current = dayjs(startDate);
    const end = dayjs(endDate);

    while (
      current.isBefore(end) ||
      current.isSame(end, "day")
    ) {

      const key = current.format("YYYY-MM-DD");

      labels.push(
        current.format("DD/MM")
      );

      const day = dailyMap?.[key] ?? {};

      let value = 0;

      // RAW
      if (type === "raw") {

        value =
          field === "costMicros"
            ? (day[field] || 0) / 1_000_000
            : day[field] || 0;
      }

      // CALCULATED
      if (
        type === "cal" &&
        day[cal2] > 0
      ) {

        value =
          day[cal1] / day[cal2];

        if (cal1 === "costMicros") {
          value /= 1_000_000;
        }

        if (unit === "%") {
          value *= 100;
        }

        if (cpm) {
          value *= 1000;
        }
      }

      // MONEY FIELD
      const isMoneyField =
        field === "cost" ||
        field === "costMicros" ||
        field === "cpc" ||
        field === "cpa" ||
        cal1 === "cost" ||
        cal1 === "costMicros";

      // CONVERT CURRENCY
      if (
        isMoneyField &&
        currency === "USD"
      ) {

        value = CurrencyConverter(
          value,
          currency,
          usdRate
        );
      }

      data.push(
        Number(value.toFixed(2))
      );

      current = current.add(
        1,
        "day"
      );
    }

    return {
      labels,
      data
    };

  }, [
    dailyMap,
    startDate,
    endDate,
    type,
    field,
    cal1,
    cal2,
    unit,
    currency,
    usdRate
  ]);
};